.footer-bar {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    border-top: 1px solid var(--off-white-md);
}

.left-container {
    display: flex;
    gap: 8px;
}

/* Stack dropdowns on small screens */
@media (max-width: 1100px) {
    .footer-bar {
        height: 80px;
    }
    .left-container {
        flex-direction: column;
    }
    .picker {
        margin-right: 8px;
    }
    .left-container > *:last-child {
        margin-top: 4px;
    }
}

@media (max-width: 1200px) {
    .label {
        display: none;
    }
}
